import * as yup from "yup"

export const validationSchema = yup.object().shape({
    shop_transaction_id: yup.string().label("Shop transaction").required(),
    job_position_id: yup.string().label("Job Position").required(),
}) 